import axios from 'axios'
import { API_BASE_URL } from '@/shared/services/api'

export const qualityControlApi = {
  /**
   * Get quality control metrics for opt-in and intake submissions
   */
  async getMetrics(params: {
    startDate?: string
    endDate?: string
    dateRange?: 'day' | 'week' | 'month' | 'year' | 'all'
    organizationId?: string
    campaignId?: string
  }) {
    const response = await axios.get(`${API_BASE_URL}/quality-control/metrics`, {
      params,
      withCredentials: true
    })
    return response.data.data
  },

  /**
   * Get paginated list of submissions with filters
   */
  async getSubmissions(params: {
    startDate?: string
    endDate?: string
    dateRange?: 'day' | 'week' | 'month' | 'year' | 'all'
    organizationId?: string
    emLevel?: string
    dmLevel?: string
    cmLevel?: string
    bmLevel?: string
    amLevel?: string
    agentId?: string
    campaignId?: string
    submissionType?: string
    status?: string
    page?: number
    limit?: number
  }) {
    const response = await axios.get(`${API_BASE_URL}/quality-control/submissions`, {
      params,
      withCredentials: true
    })
    return {
      submissions: response.data.data,
      ...response.data.pagination
    }
  },

  /**
   * Get a single submission by ID with full details
   */
  async getSubmissionById(id: string) {
    const response = await axios.get(`${API_BASE_URL}/quality-control/submissions/${id}`, {
      withCredentials: true
    })
    return response.data.data
  },

  /**
   * Get or generate PDF for a submission
   */
  async getSubmissionPdf(id: string) {
    const response = await axios.get(`${API_BASE_URL}/quality-control/submissions/${id}/pdf`, {
      withCredentials: true
    })
    return response.data.data
  }
}
